// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    /**
     * Bắt buộc ĐẦY ĐỦ thông tin hồ sơ khi tạo/sửa nhân viên.
     *
     * Cờ này chỉ chi phối ĐÚNG TÁM ô, không phải cả phiếu:
     *   địa điểm làm việc, CMT/CCCD/hộ chiếu, ngày sinh, giới tính, vị trí, khối,
     *   và "Giờ làm việc" — vốn là MỘT nhãn nhưng HAI ô: giờ (workhour) + ngày (workday).
     *   false -> tám ô trên không bắt buộc và ẩn dấu *
     *   true  -> tám ô trên bắt buộc trở lại, đúng hành vi cũ
     *
     * Mọi ô khác bắt buộc trong MỌI trường hợp, không đi qua cờ: mã nhân viên, đơn vị, họ đệm,
     * tên, quốc tịch, cấp bậc, số điện thoại, email cá nhân, hiện trạng, thời hạn.
     * Riêng số điện thoại, email cá nhân và hiện trạng thì backend chặn sẵn (validPersonal gọi
     * getCountryMobileId().equals() nên null là NPE; service ném "Hiện trạng yêu cầu"), bỏ dấu *
     * ở đó chỉ đổi lỗi tại chỗ thành toast từ máy chủ chứ không nới được gì.
     *
     * Dựng cờ vì lúc nhận danh sách nhân sự từ khách thường thiếu đúng bảy mục đó; bắt đủ ngay
     * từ đầu thì không tạo nổi hồ sơ nào.
     */
    hoSoBatBuocDayDu: false,
    apiUrl: {
        account: '/api/account'
    },
    firebase: {
        apiKey: 'AIzaSyB8W3eo8YjzSMt3TG5TL_TU7PSVs7ONIoI',
        authDomain: 'hebela-store-dev.firebaseapp.com',
        projectId: 'hebela-store-dev',
        storageBucket: 'hebela-store-dev.appspot.com',
        messagingSenderId: '715244979009',
        appId: '1:715244979009:web:da27ee1644b2173449d7c0',
        measurementId: 'G-K8BYRMDH7X'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
